import store from "../../store";
import * as ACTIONS from "./action";

const obj = {
  // addContentPage: (data) => store.dispatch(ACTIONS.addContentPage(data)),
  // getAllcontentPages: () => store.dispatch(ACTIONS.getAllcontentPages()),
  // getContentById: (data) => store.dispatch(ACTIONS.getContentById(data)),
  // updateContentPage: (data) => store.dispatch(ACTIONS.updateContentPage(data)),
  // deleteContentPages: (data) =>
  //   store.dispatch(ACTIONS.deleteContentPages(data)),
  // getAllFAQs: () => store.dispatch(ACTIONS.getAllFAQs()),
  // getFAQsById: (data) => store.dispatch(ACTIONS.getFAQsById(data)),
  // addFAQs: (data) => store.dispatch(ACTIONS.addFAQs(data)),
  // deleteFAQsById: (data) => store.dispatch(ACTIONS.deleteFAQsById(data)),
  // updateFAQs: (data) => store.dispatch(ACTIONS.updateFAQs(data)),
  // getAllNotification: () => store.dispatch(ACTIONS.getAllNotification()),
  // getNotificationById: (data) =>
  //   store.dispatch(ACTIONS.getNotificationById(data)),
  // addNotification: (data) => store.dispatch(ACTIONS.addNotification(data)),
  // deleteNotificationById: (id) =>
  //   store.dispatch(ACTIONS.deleteNotificationById(id)),
  // updateNotification: (data) =>
  //   store.dispatch(ACTIONS.updateNotification(data)),
  // changePassword: (data) => store.dispatch(ACTIONS.changePassword(data)),
  resetPassword: (data) => store.dispatch(ACTIONS.resetPassword(data)),
  // getAllContact: () => store.dispatch(ACTIONS.getAllContact()),
  // getUserExists: (address) => store.dispatch(ACTIONS.getUserExists(address)),
  // deleteUser: (address) => store.dispatch(ACTIONS.deleteUser(address)),
  // deleteUsers: () => store.dispatch(ACTIONS.deleteUsers()),
  // getAllProperty: () => store.dispatch(ACTIONS.getAllProperty()),
  // getPropertyById: (id) => store.dispatch(ACTIONS.getPropertyById(id)),
  // updateProperty: (id, propertyData) =>
  //   store.dispatch(ACTIONS.updateProperty(id, propertyData)),
  // deleteProperty: (id) => store.dispatch(ACTIONS.deleteProperty(id)),
  // getAdmin: () => store.dispatch(ACTIONS.getAdmin()),
  // uploadAdminImage: (data) => store.dispatch(ACTIONS.uploadAdminImage(data)),
  // updateAdminProfile: (data) =>
  //   store.dispatch(ACTIONS.updateAdminProfile(data)),
  // addUserDetails: (data) => store.dispatch(ACTIONS.addUserDetails(data)),
  // getUserProfileDetails: (data) =>
  //   store.dispatch(ACTIONS.getUserProfileDetails(data)),
  // addProperty: (propertyData) =>
  //   store.dispatch(ACTIONS.addProperty(propertyData)),
  // getAllUsers: () => store.dispatch(ACTIONS.getAllUsers()),
  // getUserDetails: (address) => store.dispatch(ACTIONS.getUserDetails(address)),
  // approveUser: (_id) => store.dispatch(ACTIONS.approveUser(_id)),
  // rejectUser: (_id) => store.dispatch(ACTIONS.rejectUser(_id)),
  // uploadImageDetails: (file) =>
  //   store.dispatch(ACTIONS.uploadImageDetails(file)),
};

export default obj;
